import { DEFAULT_SCRAMBLE_LENGTH_KEY } from '../core/storage.js';
import {
  DEFAULT_SCRAMBLE_LENGTH,
  clampScrambleLength,
} from './scramble-generator.js';

export function loadDefaultScrambleLength(storage = window.localStorage) {
  try {
    const stored = storage.getItem(DEFAULT_SCRAMBLE_LENGTH_KEY);
    if (stored === null) return DEFAULT_SCRAMBLE_LENGTH;
    const parsed = Number(stored);
    if (!Number.isFinite(parsed)) {
      storage.removeItem(DEFAULT_SCRAMBLE_LENGTH_KEY);
      return DEFAULT_SCRAMBLE_LENGTH;
    }
    const normalized = clampScrambleLength(parsed);
    if (stored !== String(normalized)) storage.setItem(DEFAULT_SCRAMBLE_LENGTH_KEY, String(normalized));
    return normalized;
  } catch {
    return DEFAULT_SCRAMBLE_LENGTH;
  }
}

export function saveDefaultScrambleLength(value, storage = window.localStorage) {
  const parsed = String(value).trim() === '' ? Number.NaN : Number(value);
  const normalized = Number.isFinite(parsed)
    ? clampScrambleLength(parsed)
    : DEFAULT_SCRAMBLE_LENGTH;
  storage.setItem(DEFAULT_SCRAMBLE_LENGTH_KEY, String(normalized));
  return normalized;
}
